import React, { useEffect, useState } from "react";
import "./../App.css";
import { auth, db } from "../firebase";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";

function Menu() {
  const [open, setOpen] = useState(null);
  const [userData, setUserData] = useState(null);

  const [hotelname, sethotelname] = useState('');
  const [roomposting, setroomposting] = useState('');
  const [gstbill, setgstbill] = useState('');
  const [customerQr, setcustomerQr] = useState('');

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (!user) return;
      setUserData(user);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!userData) return;

    const fetchAll = async () => {
      try {
        // 1️⃣ Get the propertyId of the logged-in user
        const roleRef = doc(db, "authroles", userData.uid);
        const roleSnap = await getDoc(roleRef);

        if (!roleSnap.exists() || !roleSnap.data().propertyId) return;

        const propertyId = roleSnap.data().propertyId;

        // 2️⃣ Query restodetails collection where propertyId matches
        const restodetailsQuery = query(
          collection(db, "properties"),
          where("propertyId", "==", propertyId)
        );

        const querySnap = await getDocs(restodetailsQuery);

        // 3️⃣ Map the results
        const allRestoDetails = querySnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));


        // 4️⃣ If you want to store some details in state (e.g., first resto)
        if (allRestoDetails.length > 0) {
          const firstResto = allRestoDetails[0];
          sethotelname(firstResto.hotelname || "");
          setroomposting(firstResto.roomposting || "");
          setgstbill(firstResto.gstbill || "");
          setcustomerQr(firstResto.customerQr || "");
        }

        // Optionally store the full list
        // setAllRestos(allRestoDetails);

      } catch (err) {
        console.log({ icon: "error", title: err.message });
      }
    };

    fetchAll();
  }, [userData]);

  const toggle = (name) => {
    setOpen(open === name ? null : name);
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary " style={{backgroundColor:"teal"}}>

      <a href="#0" className="brand-link p-3">
        <img
          src="logo.png"
          alt="A"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".8", height: 50, width: 35 }}
        />
        <span className="brand-text "><b>RESZIO</b></span>
      </a>

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column">
            {/* Resto */}
            <li className="nav-item">
              <a href="/home" className="nav-link">
                <i className="nav-icon fa fa-home" />
                <p>Home</p>
              </a>
            </li>
            {/* Orders */}
            <li className={`nav-item ${open === "orders" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("orders")}>
                <i className="nav-icon fa fa-shopping-cart" />
                <p>Orders <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <a href="/table-orders" className="nav-link"><p>Table Orders</p></a>
                </li>
                <li className="nav-item">
                  <a href="/view-orders" className="nav-link"><p>View Orders</p></a>
                </li>
                {/* <li className="nav-item">
                  <a href="/room-posting" className="nav-link"><p>Room Posting</p></a>
                </li> */}
              </ul>
            </li>

            {/* Purchase */}
            <li className={`nav-item ${open === "purchase" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("purchase")}>
                <i className="nav-icon fa fa-book" />
                <p>Purchase <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/add-purchase" className="nav-link"><p>Add Purchase</p></a></li>
                <li className="nav-item"><a href="/view-purchase" className="nav-link"><p>View Purchase</p></a></li>
              </ul>
            </li>

            {/* Customers */}
            <li className={`nav-item ${open === "customers" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("customers")}>
                <i className="nav-icon fa fa-user" />
                <p>Customers <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/customers" className="nav-link"><p>Customers</p></a></li>
                <li className="nav-item"><a href="/customer-account" className="nav-link"><p>Customer Account</p></a></li>
                <li className="nav-item"><a href="/table-reservation" className="nav-link"><p>Table Reservation</p></a></li>
              </ul>
            </li>

            {/* Dealers */}
            <li className={`nav-item ${open === "dealers" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("dealers")}>
                <i className="nav-icon fa fa-user-circle" />
                <p>Dealers <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/dealer-details" className="nav-link"><p>Dealer Details</p></a></li>
                <li className="nav-item"><a href="/dealer-account" className="nav-link"><p>Dealer Account</p></a></li>
              </ul>
            </li>

            {/* Products */}
            <li className={`nav-item ${open === "products" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("products")}>
                <i className="nav-icon fa fa-cubes" />
                <p>Menu Items <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/menuitems-details" className="nav-link"><p>Menu Items </p></a></li>
                <li className="nav-item"><a href="/menuitems-category" className="nav-link"><p>Menu  Category</p></a></li>
                <li className="nav-item"><a href="/menuitems-unit" className="nav-link"><p>Menu  Unit</p></a></li>
              </ul>
            </li>

            {/* Seating */}
            <li className={`nav-item ${open === "seating" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("seating")}>
                <i className="nav-icon fa fa-table" />
                <p>Seating Section<i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/seating-details" className="nav-link"><p>Seating Details</p></a></li>
                <li className="nav-item"><a href="/seating-category" className="nav-link"><p>Seating Category</p></a></li>
                {
                  customerQr === 'Yes' &&
                  <li className="nav-item"><a href="/seating-qr-codes" className="nav-link"><p>Seating Qr Codes</p></a></li>
                }
              </ul>
            </li>

            {/* Staff */}
            <li className="nav-item">
              <a href="/staff-details" className="nav-link">
                <i className="nav-icon fa fa-users" />
                <p>Staff Details</p>
              </a>
            </li>

            <li className={`nav-item ${open === "restos" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("restos")}>
                <i className="nav-icon fa fa-building" />
                <p>Master <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/resto-details" className="nav-link"><p>Resto Details</p></a></li>
                <li className="nav-item"><a href="/resto-users" className="nav-link"><p>Resto Users</p></a></li>
                <li className="nav-item"><a href="/payment-modes" className="nav-link"><p>Payment Modes</p></a></li>
                <li className="nav-item"><a href="/captain-assign" className="nav-link"><p>Captain Assign</p></a></li>
                
              </ul>
            </li>
            {/* Reports */}
            <li className={`nav-item ${open === "reports" ? "menu-open" : ""}`}>
              <a href="#0" className="nav-link" onClick={() => toggle("reports")}>
                <i className="nav-icon fa fa-file" />
                <p>Reports <i className="right fa fa-angle-left" /></p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item"><a href="/customer-outstanding" className="nav-link"><p>Customer Outstanding</p></a></li>
                {
                  roomposting === 'Yes' &&
                  <li className="nav-item"><a href="/room-posting-report" className="nav-link"><p>Room Posting</p></a></li>
                }
                <li className="nav-item"><a href="/sale-purchase-report" className="nav-link"><p>Sale / Purchase</p></a></li>
                <li className="nav-item"><a href="/customerwise-report" className="nav-link"><p>Customer Wise Sale</p></a></li>
                <li className="nav-item"><a href="/productwise-sale-report" className="nav-link"><p>Product Wise Sale</p></a></li>
                <li className="nav-item"><a href="/paymodewise-report" className="nav-link"><p>Paymode Wise</p></a></li>
                <li className="nav-item"><a href="/kot-cancel-logs" className="nav-link"><p>KOT Cancel Logs</p></a></li>
                <li className="nav-item"><a href="/user-logs" className="nav-link"><p>User Logs</p></a></li>
                <li className="nav-item"><a href="/table-switch-logs" className="nav-link"><p>Table Switch Logs</p></a></li>
                {/* <li className="nav-item"><a href="/daily-denomination" className="nav-link"><p>Daily Denomination</p></a></li> */}
              </ul>
            </li>

            {/* Staff */}
            <li className="nav-item">
              <a href="/settings" className="nav-link">
                <i className="nav-icon fa fa-cog" />
                <p>Settings</p>
              </a>
            </li>



          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Menu;
